import { getArticleBySlug } from 'helpers/strapi'
import { ArticleType } from 'helpers/strapi/types'
import { SimpleStrapiPage } from 'routes/Articles/Category/Page'
import { HowWeAreDifferentSidebar } from 'routes/HowWeAreDifferent'
import { PAGE_REVALIDATE_TIME } from 'routes/constants'

const ARTICLE_SLUG = 'how-we-are-different'

export default function HowWeUseAiPage({ article }: { article: ArticleType }) {
  return (
    <SimpleStrapiPage article={article}>
      <HowWeAreDifferentSidebar />
    </SimpleStrapiPage>
  )
}

export async function getStaticProps() {
  const article = await getArticleBySlug(ARTICLE_SLUG, true)

  if (!article) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      article,
    },
    revalidate: PAGE_REVALIDATE_TIME, // In seconds
  }
}
